import React, { useState } from 'react';
import { useWeb3 } from '../contexts/Web3Context';
import { FaCopy, FaCheck, FaRocket, FaGift, FaCoins } from 'react-icons/fa';

const ReferralWidget = () => {
    const { wallet } = useWeb3();
    const [copied, setCopied] = useState(false);

    if (!wallet) {
        return (
            <div className="card" style={{ padding: '20px', marginTop: '20px', textAlign: 'center', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', color: 'white' }}>
                <h4>¡Gana con Referidos!</h4>
                <p style={{ fontSize: '0.9em', opacity: 0.9 }}>
                    Conecta tu billetera para obtener tu enlace único, ganar 3% de comisiones y regalar 1% extra.
                </p>
            </div>
        );
    }

    const referralLink = `${window.location.origin}/invitacion?ref=${wallet.accounts[0].address}`;

    const handleCopy = () => {
        navigator.clipboard.writeText(referralLink);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="card" style={{
            marginTop: '20px',
            textAlign: 'center',
            background: 'linear-gradient(135deg, #1a237e 0%, #283593 100%)',
            border: '2px solid #ffd700',
            boxShadow: '0 0 10px rgba(255, 215, 0, 0.2)',
            padding: '0',
            overflow: 'hidden'
        }}>
            {/* Header with Gold Gradient Text */}
            <div style={{ padding: '15px', paddingBottom: '5px' }}>
                <h4 style={{
                    margin: '0 0 2px 0',
                    fontSize: '1.1rem',
                    background: 'linear-gradient(to right, #ffd700, #ffecb3, #ffd700)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                }}>
                    <FaRocket color="#ffd700" /> Invita y Gana
                </h4>
                <p style={{ color: '#aaa', fontSize: '0.8rem', margin: 0 }}>¡Haz crecer tu comunidad XCoin!</p>
            </div>

            {/* Rewards Section */}
            <div style={{ padding: '0 15px 15px 15px' }}>
                <div style={{
                    background: 'rgba(255,255,255,0.08)',
                    borderRadius: '10px',
                    padding: '10px',
                    marginBottom: '10px',
                    backdropFilter: 'blur(5px)',
                    border: '1px solid rgba(255,255,255,0.1)'
                }}>
                    <div style={{ marginBottom: '8px' }}>
                        <div style={{ fontSize: '0.8rem', color: '#ccc', marginBottom: '2px' }}>TÚ RECIBES</div>
                        <div style={{ fontSize: '1.4rem', fontWeight: 'bold', color: '#ffd700', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <FaGift /> 3% <span style={{ fontSize: '0.75rem', color: '#fff', alignSelf: 'center', fontWeight: 'normal' }}>en Bonos</span>
                        </div>
                    </div>
                    <div style={{ borderTop: '1px dashed rgba(255,255,255,0.2)', margin: '8px 0' }}></div>
                    <div>
                        <div style={{ fontSize: '0.8rem', color: '#ccc', marginBottom: '2px' }}>TU AMIGO RECIBE</div>
                        <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#4caf50', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <FaCoins /> +1% <span style={{ fontSize: '0.75rem', color: '#fff', alignSelf: 'center', fontWeight: 'normal' }}>Extra</span>
                        </div>
                    </div>
                </div>

                <div style={{ fontSize: '0.7rem', color: '#888', fontStyle: 'italic', marginBottom: '10px', lineHeight: '1.2' }}>
                    *Requisito: Los bonos se liberan tras 90 días de holding. <a href="/referidos-info" target="_blank" style={{ color: '#ffd700', textDecoration: 'underline' }}>Ver condiciones</a>
                </div>

                {/* Link Box */}
                <div style={{
                    background: '#111',
                    padding: '8px 10px',
                    borderRadius: '6px',
                    fontSize: '0.75rem',
                    color: '#fff',
                    marginBottom: '10px',
                    border: '1px solid #444',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '10px'
                }}>
                    <span style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: '#aaa'
                    }}>
                        {referralLink}
                    </span>
                </div>

                {/* Action Button */}
                <button
                    onClick={handleCopy}
                    style={{
                        background: copied ? '#28a745' : 'linear-gradient(90deg, #ffd700, #ffecb3)',
                        color: copied ? 'white' : '#000',
                        border: 'none',
                        padding: '10px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        fontWeight: 'bold',
                        fontSize: '0.9rem',
                        transition: 'all 0.3s ease',
                        boxShadow: copied ? 'none' : '0 3px 10px rgba(255, 215, 0, 0.2)'
                    }}
                >
                    {copied ? <><FaCheck /> ¡Enlace Copiado!</> : <><FaCopy /> Copiar Mi Enlace</>}
                </button>
            </div>
        </div>
    );
};

export default ReferralWidget;
